export default function CTA() {
  return (
    <section className="py-20 lg:py-32 bg-[#0A1628]">
      <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <div className="space-y-8">
          <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight">
            Ready to Transform<br />Your Business?
          </h2>
          
          <p className="text-xl text-white/70 max-w-2xl mx-auto">
            Join hundreds of successful African businesses that trust ACE Consultancy Africa
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <button className="bg-[#D4AF37] text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#C19B2E] transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
              Get Started Today
            </button>
            <button className="border-2 border-white text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap">
              View Case Studies
            </button>
          </div>

          <div className="grid sm:grid-cols-3 gap-8 pt-12">
            <div className="space-y-2">
              <div className="text-4xl font-bold text-[#D4AF37]">10+</div>
              <div className="text-white/70 text-sm">Years of Excellence</div>
            </div>
            <div className="space-y-2">
              <div className="text-4xl font-bold text-[#D4AF37]">500+</div>
              <div className="text-white/70 text-sm">Satisfied Clients</div>
            </div>
            <div className="space-y-2">
              <div className="text-4xl font-bold text-[#D4AF37]">15+</div>
              <div className="text-white/70 text-sm">African Countries</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
